
import {useNavigate, useSearchParams} from "react-router-dom";
import Grid from "@mui/material/Grid";
import * as React from "react";
import {useEffect, useState} from "react";
import useRootHook from "../../hooks/useRoot";
import helpers from "../../helpers/common";
import MerchantForm from "./MerchantForm";
import merchants from "../../models/merchants";
import currencies from "../../models/currencies";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function MerchantEdit() {
    const [searchParams] = useSearchParams();
    const [merchantData, setMerchantData] = useState(null)
    const [fields, setFields] = useState({})
    const [errors, setErrors] = useState({});
    const [currenciesData, setCurrenciesData] = useState([]);
    const {setShowLoader} = useRootHook();
    const navigate = useNavigate()

    useEffect(() => {
        setShowLoader(true)
        merchants.get(searchParams.get('uuid'))
            .then((data) => {
                setShowLoader(false)
                data && setMerchantData(data)
                data && setFields({ ...data, checkout_mode: data.checkout_mode || 'redirect_checkout' })
            }).catch(() => setShowLoader(false))

        currencies.index()
            .then((data) => {
                const list = Array.isArray(data) ? data.filter((c) => c.enabled) : [];
                setCurrenciesData(list);
            })
            .catch(() => setCurrenciesData([]));
    }, [])

    const handleChange = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof merchants.fieldValidator[name] === 'function'
        && merchants.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = merchants.methodValidator.edit(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        merchants.edit(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/merchants')
            }).catch(() => setShowLoader(false))
    }

    if (!merchantData) return null

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Edit merchant"
                breadcrumbs={[['Dashboard', '/'], ['Merchants', '/merchants'], ['Edit', `/merchants/edit?uuid=${helpers.UUIDv4Transform(merchantData.uuid)}`]]}
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <MerchantForm fields={fields} errors={errors} handleChange={handleChange}
                              handleBlur={handleBlur} handleSubmit={handleSubmit}
                              currenciesData={currenciesData} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}